import { isNotDefined } from '@togglecorp/fujs';
import { nonFieldError } from './types.js';

function getErrorObject(value) {
  if (isNotDefined(value)) {
    return undefined;
  }

  if (typeof value === 'string') {
    // FIXME: memoize this
    return {
      [nonFieldError]: value
    };
  }

  return value;
}
function getErrorString(value) {
  if (isNotDefined(value)) {
    return undefined;
  }

  if (typeof value === 'string') {
    return value;
  }

  return value[nonFieldError];
}

export { getErrorObject, getErrorString };
//# sourceMappingURL=errorAccessHelper.js.map
